module.exports = __webpack_public_path__ + "0f6a72f4405b86cc35a4d12351ddc54b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-21.png
// module id = 3005
// module chunks = 0